import theme from '../../styles/theme.css?polyfill=type-css' ;

import sheet from './ctc-block.css?polyfill=type-css' ;

import copyIcon from '../../assets/copy-button.svg?type=raw';

const template = document.createElement('template');

export default class CopyToClipboardBlock extends HTMLElement {
  selectCommandRunnerIdx;
  snippetContents;
  root                   ;

  constructor() {
    super();
    this.selectCommandRunnerIdx = 0;
    this.snippetContents = '';
    this.root = null;
  }

  connectedCallback() {
    const variant = this.getAttribute('variant');

    if (!this.shadowRoot && typeof window !== 'undefined') {
      if (variant === 'snippet') {
        const heading = this.getAttribute('heading');
        const headingHtml = heading ? `<span class="heading">${heading}</span>` : '';

        this.snippetContents = this.textContent.trim();
        template.innerHTML = `
          <div class="snippet-container">
            <div class="snippet">
              ${headingHtml}
              <span class="copy-icon">
                ${copyIcon}
              </span>
              ${this.innerHTML}
            </div>
          </div>
        `;
      } else if (variant === 'shell') {
        this.snippetContents = this.textContent.trim();
        template.innerHTML = `
            <div class="shell-container">
              <span class="copy-icon">
                ${copyIcon}
              </span>
              ${this.innerHTML}
            </div>
          `;
      } else {
        console.warn(`Unknown variant provided => ${variant}`);
      }

      this.root = this.attachShadow({ mode: 'open' });

      if (this.root) {
        this.root.appendChild(template.content.cloneNode(true));

        switch (variant) {
          case 'snippet':
            this.root
              ?.querySelector('.copy-icon')
              ?.addEventListener('click', this.copySnippetToClipboard.bind(this));
            break;
          case 'shell':
            this.root
              ?.querySelector('.copy-icon')
              ?.addEventListener('click', this.copyShellScriptToClipboard.bind(this));
            break;
        }

        this.root.adoptedStyleSheets = [theme, sheet];
      }
    }
  }

  copySnippetToClipboard() {
    const contents = this.snippetContents;

    navigator.clipboard.writeText(contents);
    console.log('copying the following contents to your clipboard =>', contents);
  }

  copyShellScriptToClipboard() {
    const contents = this.getAttribute('paste-contents')?.trim();

    if (!contents) {
      console.warn('No content provided to copy to clipboard');
      return;
    }

    navigator.clipboard.writeText(contents);
    console.log('copying the following contents to your clipboard =>', contents);
  }
}

customElements.define('wcc-ctc-block', CopyToClipboardBlock);
